import React from 'react';
import { Stack } from '@mui/material';
import {
    PayerEditor,
    ProductEditor,
    EffectiveDateEditor,
    EndDateEditor,
    FinancialClassEditor,
    CalcTypeEditor,
    FacilityTypeEditor
} from '../../../../fieldEditors/contractEditors';

export const ContractFormFields: React.FC = () => {
    return (
        <Stack spacing={3} sx={{ mt: 1 }}>
            {/* Top Row: Payer and Product */}
            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                <PayerEditor />
                <ProductEditor />
            </Stack>

            {/* Second Row: Dates and Classifications */}
            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                <EffectiveDateEditor />
                <EndDateEditor />
                <FinancialClassEditor />
                <CalcTypeEditor />
                <FacilityTypeEditor />
            </Stack>
        </Stack>
    );
};
